import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ButtonTooltip from './ButtonTooltip';

const DraggableList = ({
  items,
  onDragEnd,
  onAdd,
  onRemove,
  onItemChange,
  addButtonText = "Add Item",
  renderItem,
  minItems = 1
}) => {
  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="draggable-list">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items.map((item, index) => (
                <Draggable
                  key={item.id}
                  draggableId={item.id}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      className="px-3 pb-2 rounded"
                    >
                      <div className="d-flex align-items-start gap-3">
                        <div
                          {...provided.dragHandleProps}
                          className="drag-handle mt-2"
                        >
                          <i className="fas fa-grip-vertical text-muted"></i>
                        </div>
                        <div className="flex-grow-1">
                          {renderItem(item, index)}
                        </div>
                        <div className="mt-2">
                          {items.length > minItems && (
                            <ButtonTooltip
                              type="delete"
                              btnId={`delete-item-${item.id}`}
                              onClick={() => onRemove(item.id)}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      
      <div className="text-end mt-3">
        <ButtonTooltip
          type="add"
          btnId="add-item"
          onClick={onAdd}
          text={addButtonText}
        />
      </div>
    </div>
  );
};

export default DraggableList;